import ApiResponseDisplayer from '@components/ApiResponseDisplayer';
import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import Page from '@components/Page';
import UploadComponent from '@components/UploadComponent';
import { IWorkstation } from '@interfaces/Workstation';
import AppContext from '@services/Context';
import WorkstationService from '@services/Workstation';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Form, Input, Modal, Row } from 'antd';
import _ from 'lodash';
import findIndex from 'lodash/findIndex';
import React, { Component } from 'react';

import Table from '../components/TableComponent';

interface WorkstationProductionLineContainerProps {
  match: any,
  form: any,
}
interface WorkstationProductionLineContainerState {
  serverResponse: any;
  search: string;
  isLoading: boolean;
  showFormModal: boolean;
  imageUpload: string;
  imageFileList: any[];
  loadingRequest: boolean;
  imageValidator: Function | null;
  tableData: IWorkstation[];
  filteredTableData: IWorkstation[];
  editItem?: IWorkstation;
}

const tableColumns = [{
  title: 'common.stations',
  dataIndex: 'code',
  key: 'code',
}, {
  title: 'common.image',
  dataIndex: 'photo',
  key: 'photo',
}, {
  title: 'table.actions',
  dataIndex: 'action',
  key: 'action',
  width: '30%',
}];

const FormItem = Form.Item;
const workstationService: WorkstationService = new WorkstationService();
export default class WorkstationProductionLineContainer extends Component<WorkstationProductionLineContainerProps, WorkstationProductionLineContainerState> {

  private unit: string = '';

  constructor(props: any) {
    super(props);

    this.state = {
      isLoading: true,
      showFormModal: false,
      tableData: [],
      filteredTableData: [],
      search: '',
      editItem: {
        id: '',
        code: '',
        photo: '',
      },
      serverResponse: undefined,
      imageUpload: '',
      imageFileList: [],
      loadingRequest: false,
      imageValidator: null,
    };

    this.onModalImageChanged = this.onModalImageChanged.bind(this);
    this.setImageValidator = this.setImageValidator.bind(this);
    this.onRemoveModalImage = this.onRemoveModalImage.bind(this);
  }

  setUnit(unit: string) {
    this.unit = unit;
  }

  componentDidMount() {
    this.getWorkstations(true, true);
  }

  toggleFormModal = () =>
    this.setState({
      showFormModal: !this.state.showFormModal,
      serverResponse: undefined,

      imageFileList: [],
      // tags: [],
      editItem: {
        id: '',
        code: '',
        photo: '',
      },
    });


  setImageValidator(imageValidator: Function) {
    this.setState({ imageValidator })
  }

  getWorkstations = async (reset: boolean, showLoading: boolean) => {
    this.setState({ isLoading: true, showFormModal: false });

    try {
      const data: any = await workstationService.listAll(this.unit);
      const dataTableCreate: any = [];
      data.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          code: item.code,
          photo: (item.photo) ? item.photo : '-',
          createdAt: item.createdAt,
          action: true
        })
      })

      this.setState({
        isLoading: false,
        tableData: dataTableCreate,
      });

      this.formatImageList(data);
    } catch (error) {
      console.warn(error);
      this.setState({
        isLoading: false,
      });
    }
  }

  openEditModal = async (editItem: IWorkstation) => {
    let imgList = await this.formatImageList(editItem) || [];

    this.setState({
      editItem,
      imageFileList: imgList,
      showFormModal: true
    });

    this.props.form.setFieldsValue(
      {
        code: editItem.code,
      });
  };
  formatImageList = async (workstation: IWorkstation) => {
    let imgList: any[] = [];

    if (workstation.photo !== "" && workstation.photo && workstation.photo !== '-')
      imgList.push({
        uid: '1',
        name: 'image.jpg',
        url: workstation.photo || "",
        thumbUrl: workstation.photo || "",
        status: 'done'
      });

    return imgList;
  }

  onSubmit = async () => {
    const { tableData, editItem, loadingRequest } = this.state;

    const form = this.props.form;

    this.setState({ loadingRequest: true });

    await form.validateFields((err: any, values: any) => {
      if (err) {
        console.log("Has error");
        return;
      }
    });

    try {
      let nextTableData: IWorkstation[] = [];
      let values = await form.getFieldsValue();

      if (!!editItem.id) {
        if (editItem.photo === values.photoData) {
          values.photoData = undefined;
        }
        let dataEdit: IWorkstation;

        dataEdit = {
          id: editItem.id,
          code: values.code,
          photoData: (values.photoData == undefined || values.photoData == '' ?  null: values.photoData),
          photoRemoved: values.photoData == undefined || values.photoData == ''
        }
        const response = await workstationService.updateById(editItem.id, dataEdit, this.unit);
        const targetIndex = findIndex(
          tableData,
          (item: IWorkstation) => item.id === response.id,
        );
        nextTableData = tableData;
        if (nextTableData[targetIndex]) {
          nextTableData[targetIndex] = Object.assign(nextTableData[targetIndex], response);
        }
      } else {
        values = {
          id: Date.now(),
          ...values
        }

        const response = await workstationService.create(values, this.unit);

        nextTableData = [response, ...tableData];
      }
      const dataTableCreate: any = [];

      nextTableData.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          code: item.code,
          photo: (item.photo) ? item.photo : '-',
          action: true
        })
      })

      this.setState({ loadingRequest: false, isLoading: false, showFormModal: false, tableData: dataTableCreate });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
      this.setState({ loadingRequest: false });
    } finally {
    }
  };

  deleteWorkstation = async (id: string) => {
    try {
      // TODO: confirmar com Modal
      const { tableData } = this.state;
      const nextTableData = tableData.filter((item: IWorkstation) => item.id !== id);
      this.setState({
        isLoading: false,
        tableData: nextTableData,
      });
      await workstationService.deleteById(id, this.unit);
    } catch (e) {

      console.error(e);
    }
  };

  onModalImageChanged = async (imageData: any) => {
    if (imageData) {
      this.props.form.setFieldsValue({
        photoData: imageData

      });
    }
    this.setState({ imageUpload: imageData });
  }

  onRemoveModalImage() {
    this.props.form.setFieldsValue({
      photoData: ''
    });
    this.setState({ imageUpload: '-' });
  }

  searchData = async (event: any) => {

    let searchTableData: IWorkstation[] = [];
    const SearchValue = event === '' ? false : event.target.find.value;
    await this.setState({
      search: SearchValue,
      isLoading: true,
    })

    if (!SearchValue) {
      this.getWorkstations(true, false);
    }
    try {
      _.some(this.state.tableData, (o: any) => {
        console.log(_.includes(o.name, SearchValue))
        if (_.includes(o.name, SearchValue) || _.includes(o.code, SearchValue)) {
          searchTableData.push(o)
        }
      })
      await this.setState({
        isLoading: false,
        tableData: searchTableData
      })
    }
    catch (err) {
      console.log(err)
    }
  }

  getOptionalLabel(label: string) {
    return (
      <span>
        <span>{label}</span>
        <span className={"goepik-small-left-margin goepik-text-gray"} style={{ fontWeight: 'normal' }}>({I18n.l('common.optional')})</span>
      </span>
    )
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      isLoading,
      showFormModal,
      tableData,
      filteredTableData,
      editItem,
      serverResponse,
      search,
      loadingRequest
    } = this.state;

    if (!!isLoading) {
      return (
        <Page>
          <AppContext.Consumer>
            {({ locale, activeUnitId }) => (
              this.setUnit(activeUnitId),
              <span>{I18n.l('common.loadingTable')}</span>
            )}
          </AppContext.Consumer>
        </Page>
      );
    }

    return (
      <AppContext.Consumer>
        {({ locale, activeUnitId, theme }) => (
          <Page>
            <Wrapper>
              <Toolbar>
                <ToolbarItem>
                  <RegisterBtnComponent
                    onClick={this.toggleFormModal}
                    buttonText={I18n.l('common.register') + " " + I18n.l('labels.workstation')}
                  />
                </ToolbarItem>
                <ToolbarItem>
                  <SearchComponent
                    onSubmit={this.searchData}
                    placeholder='form.placeholders.workstationSearch'
                    defaultValue={search}
                    buttonText='form.buttons.search'
                  />
                </ToolbarItem>
              </Toolbar>

              {tableData.length > 0 && (
                <div className={'goepik-component-tablesize'}>
                  <Table
                    columns={tableColumns}
                    data={filteredTableData.length > 0 ? filteredTableData : tableData}
                    onEdit={this.openEditModal}
                    onDelete={this.deleteWorkstation}
                    noPagination={true}
                    showConfirmationModal={false}
                  />
                </div>
              )}
              {tableData.length === 0 && <p>{locale && I18n.l('common.noResult')}</p>}
              {showFormModal && (
                <Modal onCancel={this.toggleFormModal} visible={showFormModal} closable={false} footer={false}>
                  <ModalTitle>{I18n.l('form.titles.workstationForm')}</ModalTitle>
                  <ModalContent>
                    <Form hideRequiredMark={true}>
                      <FormItem
                        label={I18n.l('form.labels.code')}
                        colon={false}
                      >
                        {getFieldDecorator('code', {
                          rules: [
                            { required: true, message: I18n.l('form.validation.field.required'), whitespace: false },
                            {
                              min: 3, message: I18n.l('form.validation.text.min')
                            },
                            {
                              max: 15, message: I18n.l('form.validation.text.max')
                            }],
                          initialValue: ''
                        }
                        )(
                          <Input />
                        )}
                      </FormItem>

                      <FormItem
                        label={this.getOptionalLabel(I18n.l('common.image'))}
                        colon={false}
                      >
                        {getFieldDecorator('photoData', {
                          rules: [
                            { validator: (this.state.imageValidator != null) ? this.state.imageValidator : undefined },
                          ],

                        })(
                          <UploadComponent
                            onValidate={this.setImageValidator}
                            buttonTitle={I18n.l('form.products.buttonImage')}
                            customListType={'picture'}
                            defaultFileList={this.state.imageFileList}
                            onFileListChange={this.onModalImageChanged}
                            onRemoveImage={this.onRemoveModalImage}
                          />
                        )}
                      </FormItem>
                    </Form>
                    <Row className="goepik-component-padding" type="flex" align='middle' justify="end">
                      <Button disabled={loadingRequest} className="main-button" style={{ fontWeight: 'bold' }} type="primary" size="large" ghost onClick={this.toggleFormModal}>
                        {I18n.l('common.cancel').toUpperCase()}
                      </Button>

                      <RegisterBtnComponent
                        loading={loadingRequest}
                        disabled={loadingRequest}
                        onClick={this.onSubmit}
                        buttonText={I18n.l('common.save')}
                      />
                    </Row>
                    {serverResponse && (
                      <ApiResponseDisplayer theme={theme} locale={locale} data={serverResponse} />
                    )}
                  </ModalContent>
                </Modal>
              )}
            </Wrapper>

          </Page>
        )}

      </AppContext.Consumer>

    )
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
        
  .field-title{
    font-weight: bold;
  }
  .ant-form-item label{
    font-weight: bold;
  }
`;

const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
`;

const ToolbarItem = styled.div`
  flex: 1;
  margin-left: 50px;
              
  &:first-of-type {
      flex: 0;
    margin-left: 0;
  }
  `;

const ModalTitle = styled.h3`
  font-size: 22px;
`;

const ModalContent = styled.div`
    width: 100%;
                
    .field-title{
        font-weight: bold;
    }
            
    .ant-form-item{
        margin-bottom: 8px;
    }
    .ant-form-item-label label{
        font-weight: bold;             
    }
    `;

export const WorkstationProductionLineComponent = Form.create()(WorkstationProductionLineContainer);